<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'lanseedFormOnly',
})
</script>
<template>
        <a-form :model="localData" :layout="mode?'horizontal':'inline'" >
          <a-form-item :name="i" :extra="item.desc" :help="item.message"  :required="item.required" :label="item.domtype === 'hr'?'':item.name" :validate-status="item.validate"  v-for="(item,i) in localRules" :key="i" :labelCol="mode?{span: 3}:null">
            <!--数字输入框-->
            <a-input-number v-if="item.domtype=='number'" v-model:value="localData[i]" :min="item.min" :max="item.max"  :allowClear="true" />
             <a-textarea  v-else-if="item.domtype=='textarea'"  v-model:value="localData[i]" placeholder="请输入" :rows="4"  :allowClear="true" />
            <!--数字拖动框-->
            <template v-else-if="item.domtype=='slider'">
              <a-row>
                <a-col :span="12">
                  <a-slider v-model:value="localData[i]" :min="item.min" :max="item.max" />
                </a-col>
                <a-col :span="4">
                  <a-input-number v-model:value="localData[i]" :min="item.min" :max="item.max" style="margin-left: 16px" />
                </a-col>
              </a-row>
            </template>
            <!--日期选择-->
            <a-date-picker v-else-if="item.domtype == 'date'" v-model:value="localData[i]" valueFormat="YYYY-MM-DD" type="date" placeholder="选择日期"></a-date-picker>
            <!--日期时间选择-->
            <a-date-picker v-else-if="item.domtype == 'datetime'" v-model:value="localData[i]"
                valueFormat="YYYY-MM-DD HH:mm:ss" show-time placeholder="选择日期">
            </a-date-picker>
            <a-range-picker valueFormat="YYYY-MM-DD" v-else-if="item.domtype == 'datediff'" v-model:value="localData[i]" />
            <!--单项选择Radio-->
              <a-radio-group v-else-if="item.domtype == 'radio'"
                v-model:value="localData[i]">
                <a-radio style="display: block;padding:5px" v-for="(v, d) in item.data" :key="d"
                  :value="v[item.map.value]" :label="v[item.map.name]">
                  {{ v[item.map.name] }}
                  <template v-if="v.desc&&isHtml(v.desc)">
                    <a-popover title="示例" v-if="isHtml(v.desc)">
                      <InfoCircleOutlined   class="margin-left"/>
                      <div slot="content" v-html="v.desc"></div>
                    </a-popover>
                  </template>
                </a-radio>
              </a-radio-group>
              <!--开关-->
              <a-switch v-model:checked="localData[i]"
                v-else-if="item.domtype === 'switch'" placeholder="请选择">
              </a-switch>
              <!--选择框-->
              <a-select v-model:value="localData[i]"
                v-else-if="item.domtype === 'select'" placeholder="请选择">
                <a-select-option :title="it[item.map.name]" :value="it[item.map.value]" v-for="(it, i) in item.data"
                  :key="i">{{ it[item.map.name] }}</a-select-option>
              </a-select>
              <!--可多选的选择框-->
              <a-select v-else-if="item.domtype === 'mutiselect'" v-model:value="localData[i]" mode="multiple" filterable placeholder="请选择">
                <a-select-option v-for="(it, i) in item.data" :key="i" :value="it[item.map.value]">
                  {{ it[item.map.name] }}
                </a-select-option>
              </a-select>
                  <!--级联选择框-->
              <a-cascader v-else-if="item.domtype === 'cascader'"  v-model:value="localData[i]" :options="item.data" :fieldNames="item.map" placeholder="Please select" />
              <!--多选框-->
              <a-checkbox-group v-model:value="localData[i]" v-else-if="item.domtype === 'checkbox'">
                <a-checkbox style="display: block;padding:5px;margin-left:0;" :value="it[item.map.value]"
                  v-for="(it, i) in item.data" :key="i">
                  <span>{{ it[item.map.name] }}</span>
                  <span v-if="it.desc" v-html="it.desc" class="text-sm text-gray margin-left"></span>
                </a-checkbox>
              </a-checkbox-group>
               <!--数据索引-->
              <template v-else-if="item.domtype === 'list'">
                <draggable :list="localData[i]" element="ul">
                  <template #item="{ element,index }">
                    <li class="flex align-center padding-sm devider">
                    <span class="flex1 margin-right">{{ element }}</span>
                    <span class="pointer padding-sm" @click="delList(i, index)">
                      <CloseCircleOutlined />
                    </span>
                  </li>
                  </template>
                </draggable>
                <div class="text-center pointer" @click="addList(i)">
                  <div class="text-gray text-center text-sm">点击添加数据</div>
                </div>
              </template>
              <!--序列-->
              <template v-else-if="item.domtype === 'tags'">
                  <LanseedTag  v-model:value="localData[i]" :max="item.max"></LanseedTag>
              </template>
              <template v-else-if="item.domtype === 'keywords'">
                  <LanseedInputselect v-model:value="localData[i]" :options="item.data" mode="multiple"  allow-clear show-search max-tag-count="responsive"></LanseedInputselect>
              </template>
              <!--自定义值-->
              <template v-else-if="item.domtype === 'keyvalue'">
                 <LanseedKeyvalue v-model:value="localData[i]" :rules="item.rules"> </LanseedKeyvalue>
              </template>
              <!--图片上传:单图-->
              <template v-else-if="item.domtype === 'img'">
                 <LanseedUploadimg v-model:value="localData[i]"></LanseedUploadimg>
              </template>
              <!--图片上传:多图-->
              <template v-else-if="item.domtype === 'imgs'">
                 <LanseedUploadimgs v-model:value="localData[i]" :max="item.max"></LanseedUploadimgs>
              </template>
               <!--视频上传:单图-->
              <template v-else-if="item.domtype === 'video'">
                 <LanseedUploadvideo v-model:value="localData[i]"></LanseedUploadvideo>
              </template>
              <!--文件上传-->
              <template v-else-if="item.domtype === 'file'">
                 <LanseedUploadfile v-model:value="localData[i]"></LanseedUploadfile>
              </template>
              <!--编辑器-->
              <template v-else-if="item.domtype === 'editor'">
                <Toolbar
                    :editor="editorRef"
                    :mode="moded"
                />
                <Editor
                    style="height: 400px;border:1px solid #ddd"
                    v-model="localData[i]"
                    :mode="moded"
                    :defaultConfig="editorConfig"
                    @onCreated="onCreated"
                />
              </template>
              <template  v-else-if="item.domtype === 'slot'" >
                    <slot :name="i" :data="localData[i]"></slot>
              </template>
              <template  v-else-if="item.domtype === 'hr'" >
                   <a-divider />
              </template>
              <!--默认文本框-->
              <template  v-else>
                 <a-mentions v-model:value="localData[i]" v-if="item.data&&item.data.length>0"  :options="item.data"></a-mentions>
                <a-input v-else v-model:value="localData[i]" :allowClear="true"></a-input>
              </template>

          </a-form-item>
          <slot name="ext"></slot>
          <a-form-item v-if="btn">
            <div style="text-align: center;">
              <a-button type="primary" html-type="submit" @click="submit">
                <span > <SearchOutlined v-if="btnText==='搜索'" /> {{btnText}}</span>
              </a-button></div>
          </a-form-item>
          <slot name="btn"></slot>
        </a-form>
</template>
<script setup lang="ts" name="lanseedFormOnly">

import draggable from 'vuedraggable'
import {FormType} from './formtype'
import {onMounted,defineProps,ref,watch,reactive,createVNode,onBeforeUnmount,defineComponent,shallowRef,defineExpose} from 'vue'
import { Modal,Input } from 'ant-design-vue'
import {DeleteOutlined,PlusOutlined,EditOutlined,CloseCircleOutlined,SearchOutlined,InfoCircleOutlined} from   '@ant-design/icons-vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import {IEditorConfig } from '@wangeditor/editor'
import LanseedKeyvalue from './model/keyvalue.vue'
import LanseedInputselect from './model/inputselect.vue'
import LanseedUploadimg from './model/uploadimg.vue'
import LanseedUploadimgs from './model/uploadimgs.vue'
import LanseedUploadfile from './model/uploadfile.vue'
import LanseedTag from './TagsSelect/AddNewTag.vue'
import LanseedUploadvideo from './model/uploadvideo.vue'
import '@wangeditor/editor/dist/css/style.css' // 引入 css

import {baseURL} from '@/utils/util'

var localData=reactive<object>({})
var localRules=reactive<object>({})
const emit = defineEmits(['change'])
const editorRef=shallowRef()// 编辑器实例，必须用 shallowRef
const moded=ref('default') // default或 'simple'
// 组件销毁时，也及时销毁编辑器
onBeforeUnmount(() => {
        const editor = editorRef.value
        if (editor == null) return
        editor.destroy()
})
const editorConfig: Partial<IEditorConfig> = {
    MENU_CONF: {
      uploadImage:{
        server:baseURL+'/Upload/UploadWangEditor',
        fieldName:'file',
        customInsert(res: any, insertFn: InsertFnType) {  // TS 语法
            if(res.state==1){
              res.data.forEach(e=>{
                insertFn(e.url, '')
              })
            }
        },
      },
      uploadVideo:{
        server:baseURL+'/Upload/UploadWangEditor',
        fieldName:'file',
        allowedFileTypes: ['video/*'],
        timeout: 60 * 1000, // 15 秒
        customInsert(res: any, insertFn: InsertFnType) {  // TS 语法
            if(res.state==1){
              res.data.forEach(e=>{
                insertFn(e.url, '')
              })
            }
        },
      }
    }
}

const onCreated = (editor) => {
      editorRef.value = editor // 记录 editor 实例，重要！
}

const defaultRule=reactive<FormType>({
  domtype:'input',
  name:'名称',
  required:false,
  data:[],
  desc:'',
  validate:'success' ,//'success' 'warning' 'error' 'validating'
  min:0,
  max:100,
  map: { name: 'text', value: 'id' },
  check:null,
})
const props = defineProps({
  data: {
    type: Object
  },
  rules:{
    type:Object
  },
  mode:{
    type:Boolean,default:true //true:表单，false:搜索
  },
  btn:{type:Boolean,default:true},
  btnText:{type:String,default:'搜索'}
})
const  formatRules=():void=>{
  if(props.rules){
    for(var k in props.rules){
      let item =props.rules[k]
      if(item.data&&item.data.length>0){
        if(typeof(item.data[0])=='string'){
          var ar=[]
          item.data.forEach(e => {
            ar.push({id:e,text:1})
          });
          item.data=ar
        }
      }
      let ks=Object.assign({},defaultRule,item) as FormType

      localRules[k]=ks

    }
    formatData()
  }
}
//说明：只把rules中含有的参数进行熏染和格式化，在输出的时候，用localData覆盖props.data中的旧值
const formatData=():void=>{
  for(var k in localRules){
    var t=localRules[k]
    if(props.data&&props.data.hasOwnProperty(k)){
      switch(t.domtype){
        case 'number':
                if(props.data[k]){
                    if(typeof(props.data[k])!='number'){
                        localData[k]=parseInt(props.data[k])
                    }else{
                      localData[k]=props.data[k]
                    }
                }else{
                    localData[k]=0
                }
          break;
        case 'imgs':
          case 'keyvalue':
            case 'tags':
              case 'keywords':
                case 'list':
                  case 'mutiselect':
                    case 'checkbox':
                        try{
                          if(props.data[k]){
                              if(typeof(props.data[k])!='object'){
                                localData[k]=JSON.parse(props.data[k])
                              }else{
                                localData[k]=props.data[k]
                              }
                          }else{
                            localData[k]=[]
                          }
                        }catch{
                          localData[k]=[]
                        }
                      break;
        case 'datediff':
          //datadiff和别的不一样，会产生两个值，初始化的时候，需要根据对应KEY从props.data中把两个值初始化过来,datediff中要求有keys:[key1,key2]
          if(!t.keys||!Array.isArray(t.keys)){throw "datediff 类的规则中需要有 keys：Array 的值"}
          let ar=[]
          t.keys.forEach(e => {
              if(props.data.hasOwnProperty(e)){
                  ar.push(props.data[e])
              }
          });
          localData[k]=ar
          break;
          case 'hr':
            case 'empty':
            //如果是HR,什么都不做
            break;
          default:
            localData[k]=props.data[k]
          break;
      }

    }else{
      switch(t.domtype){
        case 'number':
                localData[k]=0
          break;
        case 'imgs':
          case 'keyvalue':
            case 'tags':
              case 'keywords':
                case 'list':
                  case 'mutiselect':
                    case 'checkbox':
                         localData[k]=[]
                      break;
          case 'datediff':
            if(!t.keys||!Array.isArray(t.keys)){throw "datediff 类的规则中需要有 keys：Array 的值"}
            localData[k]=[]
            break;
          default:
            localData[k]=''
          break;
      }
    }
  }
/*
  if(props.data){
    for(var k in props.data){
      if(localRules.hasOwnProperty(k)){
        const t=localRules[k]
        if(t.domtype=='number'){
                  if(props.data[k]){
                    if(typeof(props.data[k])!='number'){
                        localData[k]=parseInt(props.data[k])
                    }else{
                      localData[k]=props.data[k]
                    }
                  }else{
                    localData[k]=0
                  }
        }else if(t.domtype=='imgs'||t.domtype=='keyvalue'||t.domtype=='tags'||t.domtype=='keywords'||t.domtype=='list'||t.domtype=='mutiselect'||t.domtype=='checkbox'){
            try{
              if(props.data[k]){
                  if(typeof(props.data[k])!='object'){
                    localData[k]=JSON.parse(props.data[k])
                  }else{
                    localData[k]=props.data[k]
                  }
              }else{
                localData[k]=[]
              }
            }catch{
              localData[k]=[]
            }
        }else{
          localData[k]=props.data[k]
        }
      }
    }

  }
    */
    console.info('初始格式化数据',localData)
}

const delList=(index:number, i:number):Event=> {
      if (typeof (localData[index]) == 'object') {
        localData[index].splice(i, 1)
      } else {
        localData[index] = []
      }

    }
const addList=(index:number):Event=> {
    var v=''
    const vnode=createVNode(Input,{placeholder: '请输入',value:v,onChange:e=> { v = e.target.value }},'')

      const m=Modal.confirm({
        title:'请输入内容',
        content:vnode ,
        onOk(){
          if(v){
            var vs = []
            if (typeof (localData[index]) === 'object') {
              vs = localData[index]
            }
            vs.push(v)
            localData[index] = vs
            }
            m.destroy()

        }
      })
    }
const submit=():void=>{
    var ok=true
  for(var k in localRules){
    var item =localRules[k]
    if(item.required&&(localData[k]===undefined&&localData[k]===''&&localData[k]===null)){
      item.validate="error"
      item.message=item.name+'不可为空'
      ok=false
    }
    if(item.check){
      try{
        item.check(localData[k])
      }catch(ex){
        item.validate="error"
        item.message=ex
        ok=false
      }
    }
  }
  if(ok){
     var ds=Object.assign({},props.data,localData)
     for(var k in props.rules){
      var t=props.rules[k]
      if(t.domtype=='datediff'){
      //datediff特别处理，把取得的值回填到相应的参数上，props.data里没有这个参数，还会自动加上，最后把datediff值删除，以免影响输出
        if(!t.keys){throw k+'缺少keys:Array的设置'}
         for(var i=0;i<t.keys.length;i++){
            if(ds[k][i]){
              ds[t.keys[i]]=ds[k][i]
            }
         }
         delete ds[k]
      }
      if(t.domtype=='imgs'||t.domtype=='keyvalue'||t.domtype=='tags'||t.domtype=='keywords'||t.domtype=='list'||t.domtype=='mutiselect'||t.domtype=='checkbox'){
        if(typeof(ds[k])=='object'&&ds[k].length>0){
          ds[k]=JSON.stringify(ds[k])
        }else{
          ds[k]=null
        }
      }
     }
     console.info('输出数据',ds)
     emit('change',ds)
  }
}
watch([()=>props.data,()=>props.rules],
  (newdata,olddata) => {
    formatRules()
  },
  { immediate: true, deep: true }
)
defineExpose({
  submit
})
</script>
<style lang="scss">
  .ant-form{padding:10px}
  .ant-form-item{padding:12px 0;margin-bottom: 0;}
</style>
